import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {  ref, onMounted, Ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Watermark',
  setup(__props) {

const canvasContainer: Ref<HTMLDivElement | null> = ref(null);

const drawWatermark = () => {
    if (canvasContainer.value) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // 设置canvas大小与容器一致
        const containerRect = canvasContainer.value.getBoundingClientRect();
        canvas.width = containerRect.width;
        canvas.height = containerRect.height;

        // 设置水印样式
        ctx.font = '32px Arial';
        ctx.fillStyle = 'rgba(0, 0, 0, 0.05)';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        const angle = -30 * Math.PI / 180;
        // 绘制水印
        const watermarkText = '天鼎证券投资秦淮';
        for (let x = 0; x < canvas.width; x += 180) {
            for (let y = 0; y < canvas.height; y += 200) {
                ctx.save();
                ctx.translate(x, y);
                ctx.rotate(angle); // 旋转坐标系
                ctx.fillText(watermarkText, 0, 0); // 在旋转后的坐标系中绘制文本
                ctx.restore(); // 恢复原始坐标系
            }
        }

        // 将canvas转换为图片并设置为背景
        canvasContainer.value.style.backgroundImage = `url(${canvas.toDataURL()})`;
        canvasContainer.value.style.backgroundRepeat = 'repeat';
    }
};

onMounted(() => {
    drawWatermark();

    // 监听窗口大小变化，重新绘制水印
    window.addEventListener('resize', drawWatermark);
});







return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "canvasContainer",
    ref: canvasContainer,
    class: "canvas-container"
  }, null, 512))
}
}

})